<template>
  <div>
    <el-table :data="tableData" border>
      <el-table-column
        v-for="(item, index) in column"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.width"
      >
        <template slot-scope="scope">
          <div
            v-if="item.prop === 'status'"
            style="display: flex;align-items: center;"
            :style="{
              color: scope.row[item.prop] === 1 ? '#0aa653'
                : scope.row[item.prop] === 2 ? '#dc2626'
                  : scope.row[item.prop] === 3 ? '#909399' : '#d97706'
            }"
          >
            <div
              style="width: 5px;height: 5px;border-radius: 50%;margin-right: 5px;"
              :style="{
                background: scope.row[item.prop] === 1 ? '#0aa653'
                  : scope.row[item.prop] === 2 ? '#dc2626'
                    : scope.row[item.prop] === 3 ? '#909399' : '#d97706'
              }"
            />
            <div v-if="scope.row[item.prop] === 1">{{ $t('userManage.effective') }}</div><!--有效-->
            <div v-if="scope.row[item.prop] === 2">{{ $t('userManage.expired') }}</div><!--已到期-->
            <div v-if="scope.row[item.prop] === 3">{{ $t('collectionCenter.Disabled') }}</div><!--已停用-->
            <div v-if="scope.row[item.prop] === 4">{{ $t('userManage.expiringSoon') }}</div><!--即将到期-->
          </div>
          <div v-else>
            {{ scope.row[item.prop] }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('GlobalSetObj.operate')" fixed="right" width="240">
        <template slot-scope="scope">
          <div>
            <!--查看-->
            <el-button
              v-permit:remove="'btn:user-center:temporaryWorkerAccount:view'"
              type="text"
              size="mini"
              style="color: #0aa653;"
              @click="viewDetailData(scope.row)"
            >{{ $t('GlobalSetObj.View') }}
            </el-button>
            <!--重置密码-->
            <el-button
              v-permit:remove="'btn:user-center:temporaryWorkerAccount:resetPassword'"
              type="text"
              size="mini"
              style="color: #0aa653;"
              @click="resetPasswordFun(scope.row)"
            >
              {{ $t('collectionCenter.resetPassword') }}
            </el-button>
            <!--重新申请 v-if="scope.row.status === 2"-->
            <el-button
              v-if="scope.row.status === 2"
              v-permit:remove="'btn:user-center:temporaryWorkerAccount:reapply'"
              type="text" size="mini"
              style="color: #0aa653;"
              @click="reapplyAccount(scope.row)"
            >{{ $t('userManage.Reapply') }}</el-button>
            <!--停用-->
            <el-button
              v-if="scope.row.status !== 2 && scope.row.status !== 3"
              v-permit:remove="'btn:user-center:temporaryWorkerAccount:enableDisable'"
              type="text"
              size="mini"
              style="color: #dc2626"
              @click="changeStatus(scope.row)"
            >{{ $t('collectionCenter.Disable') }}</el-button>
            <!--启用-->
            <el-button
              v-if="scope.row.status === 3"
              v-permit:remove="'btn:user-center:temporaryWorkerAccount:enableDisable'"
              type="text"
              size="mini"
              style="color: #0aa653"
              @click="changeStatus(scope.row)"
            >{{ $t('collectionCenter.enable') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getFreelancerStatusApi } from '@/api/user';

export default {
  name: 'TableColumn',
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      column: [
        { label: this.$t('collectionCenter.compellation'), prop: 'realName', width: 180 }, // 姓名
        { label: 'CPF', prop: 'cpf', width: 180 },
        { label: this.$t('userManage.state'), prop: 'status', width: 180 }, // 状态
        { label: this.$t('userManage.LoginAccount'), prop: 'username', width: 180 }, // 登录账号
        { label: this.$t('home.position'), prop: 'positionName', width: 180 }, // 岗位
        { label: this.$t('collectionCenter.owningTransitCenter1'), prop: 'siteName', width: 180 }, // '所属转运中心'
        { label: this.$t('uploadFile.timingDays'), prop: 'validityDays', width: 140 }, // '时效天数'
        { label: this.$t('customerManagements.genterTiem'), prop: 'validFrom', width: 180 }, // '生效时间'
        { label: this.$t('seller.expirationTime'), prop: 'expireAt', width: 180 }, // '失效时间'
        { label: this.$t('GlobalSetObj.CreatePeople'), prop: 'createUserName', width: 180 }, // '创建人'
        { label: this.$t('GlobalSetObj.CreationTime'), prop: 'createTime', width: 180 } // 创建时间
      ]
    };
  },
  methods: {
    // 查看详情
    viewDetailData(row) {
      this.$emit('viewDetailData', row);
    },
    // 重置密码
    resetPasswordFun(row) {
      this.$emit('openResetPassword', row);
    },
    // 启用停用临时工账号
    changeStatus(row) {
      const actionText =
        row.status === 3
          ? this.$t('ChannelManage.confirmActivateAccount')
          : this.$t('ChannelManage.confirmDeactivateAccount');
      this.$confirm(
        actionText,
        this.$t('collectionCenter.tips'),
        {
          confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
          cancelButtonText: this.$t('collectionCenter.cancel') // '取消'
        }
      ).then(() => {
        const param = {
          id: row.id,
          type: row.status === 3 ? 1 : 2
        };
        if (row.status === 3) {
          param.validDays = 7;
        }
        getFreelancerStatusApi(param).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            this.$emit('getTableData');
          }
        });
      });
    },
    // 重新申请账号
    reapplyAccount(row) {
      this.$emit('openReapplyAccount', row);
    }
  }
};
</script>

<style scoped>

</style>
